import {Divider} from '@/components/ui/divider/Divider'
import {useTranslation} from 'react-i18next'
import {MedicalReportSectionTitle} from '../medical-report-section-title/MedicalReportSectionTitle'
import {MedicalReportTextAreaSections} from '../medical-report-text-area-sections/MedicalReportTextAreaSections'
import {renewProjectReportToSection, renewRehabilitationProjectToSection} from '../../utils'
import {RenewProjectRehabilitationSchema, RenewProjectReportsSchema} from '../../formSchemas'

export const RenewContinuousProjectSections = () => {
    return (
        <>
            <ReportSections />
            <Divider direction="horizontal" />
            <RehabilitationSections />
        </>
    )
}

export const ReportSections = () => {
    const {t} = useTranslation()
    return (
        <>
            <MedicalReportSectionTitle>{t('commons:report', {count: 1})}</MedicalReportSectionTitle>
            <MedicalReportTextAreaSections
                sectionsMap={renewProjectReportToSection}
                schema={RenewProjectReportsSchema}
            />
        </>
    )
}

export const RehabilitationSections = () => {
    const {t} = useTranslation()
    return (
        <>
            <MedicalReportSectionTitle>{t('commons:rehabilitation_project', {count: 1})}</MedicalReportSectionTitle>
            <MedicalReportTextAreaSections
                sectionsMap={renewRehabilitationProjectToSection}
                schema={RenewProjectRehabilitationSchema}
            />
        </>
    )
}
